import { Injectable } from '@angular/core';

@Injectable()
export class BookingUrl {
    public static get GET_BOOKING_DETAIL(): string { return '/api/booking/{id}/detail'; }  
    public static get GET_ALL_STATUS(): string { return '/api/booking/status'; }   
    public static get CONFIRM_BOOKING_DETAIL(): string { return '/api/booking/confirmed/'; }   
    public static get SEARCH_MEMBER():string{return '/api/booking/searchmember';}
    public static get REMOVE_BOOKING(): string { return '/api/booking/{id}/delete'; }   
    public static get SAVING_BOOKING_DETAIL():string{return '/api/Booking/savingbookingdetail/';}   
    public static get GET_CLINIC_TYPE(): string { return '/api/centre/clinicType'; }
    public static get GET_BOOKING_INIT(): string { return '/api/booking/init'; }  
    public static get ADD_BOOKING(): string { return '/api/Booking'; }  
    public static get ADD_BOOKING_CACHE(): string { return '/api/booking/addBooking'; }  
    public static get GET_FLUVACCINE_BOOKING(): string { return '/api/booking/{id}/fluVaccineBooking'; } 
    public static get GET_BOOKING_CACHE(): string { return '/api/booking/booking'; } 
    public static get UPDATE_FLUVACCINE_BOOKING(): string { return '/api/Booking/fluVaccineBooking'; }
    public static get GET_BOOKINGS(): string { return '/api/Booking/bookings'; }
    public static get ADD_NEW_MEMBERS(): string { return '/api/Booking/addmember'; }   
    public static get GET_NEW_MEMBERS(): string { return '/api/Booking/getmembers'; }   
    public static get IMPORT_FILE_MEMBER(): string { return '/api/Booking/importmember'; }       
    public static get GET_BOOKING_TYPE(): string { return '/api/Booking/bookingType'; }
    public static get GET_ALL_CLINIC(): string { return '/api/Booking/clinic'; }
    public static get GET_COUNTRY(): string { return '/api/Masterdata/country';}
    public static get GET_ALL_DESTINATION(): string { return '/api/Booking/destination'; }
    public static get CHANGE_TIME_MANAGE_BOOKING(): string { return '/api/Booking/changetimebooking/'; }
    public static get DOWNLOAD_FILE_TEMPLATE():string{return '/api/Booking/getfiletemplate'}   
    public static get GET_CHILD_FLU_VACCINE_BOOKING():string{return '/api/Booking/fluBooking/'}  
    public static get DELETE_BOOKING_CACHE():string{return '/api/booking/delete'}
    public static get GET_ALL_CENTRE_CLINC():string{return '/api/masterdata/centreclinic/dropdown-list'}
    public static get GET_ALL_REASON():string{return '/api/masterdata/reason/dropdown-list'}
    
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/booking.url.ts